import { Grid, GridProps } from '@mui/material';
export const GridComponent: React.FC<GridProps> = props => {
  return <Grid {...props}>{props.children}</Grid>;
};
